import { render, staticRenderFns } from "./GrapesJsEmailEditor.vue?vue&type=template&id=ac0d7a78"
import script from "./GrapesJsEmailEditor.vue?vue&type=script&lang=js"
export * from "./GrapesJsEmailEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports